import React, { Fragment } from 'react'
import Nav from '../../components/NavBar/Nav'
import Footer from '../../components/Footer/Footer'
import Device from '../../components/Device/Device'

const index = () => {
  return (
    <Fragment>
        <Nav/>
        <Device/>
        <Footer/>
    </Fragment>
  )
}

export default index